var ef = require('ef/ef');
import SharedInitializationService from 'services/initialization-service';

export default class InitializationService {
  static load() {
    return [ ef.enrollment.loadData(), ef.program.fetch() ];
  }

  static applyTransformations(modulesJSON, modulesContentJson, groupsJSON) {
    return SharedInitializationService.applyTransformations(modulesJSON, modulesContentJson, groupsJSON);
  }
}
